// extracted by mini-css-extract-plugin
module.exports = {"products":"_9-Un8","pagination":"-itW7","list":"_14UDt","showMore":"_34vas","productsCards":"sGpyB"};